import { render, staticRenderFns } from "./MessageTabs.vue?vue&type=template&id=4622e286&scoped=true&"
import script from "./MessageTabs.vue?vue&type=script&lang=ts&"
export * from "./MessageTabs.vue?vue&type=script&lang=ts&"
import style0 from "./MessageTabs.vue?vue&type=style&index=0&id=4622e286&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4622e286",
  null
  
)

export default component.exports